<script>
  import { createEventDispatcher } from 'svelte';

  import Modal from '@components/Modal.svelte';
  import Notification from '@utils/notification';
  import RecRequestAjax from '@ajax/rec_request';
  import { getGroupStore } from '@stores/group';
  let recRequestsStore = getGroupStore('recRequestsStore');

  import NameAndDescription from './save_rec_request/NameAndDescription.svelte';
  import Recommendations from './save_rec_request/Recommendations.svelte';
  import ThankYou from './save_rec_request/ThankYou.svelte';
  import Share from './save_rec_request/Share.svelte';

  const dispatch = createEventDispatcher();

  const STEP_THANK_YOU = 'thank-you-message';
  const STEP_RECOMMENDATIONS = 'recommendations';
  const STEP_NAME_DESCRIPTION = 'name-and-description';
  const STEP_SHARE = 'share';

  export let showModal = false;
  export let mobile = false;
  export let currentUser;
  export let group;
  export let recRequest;
  export let startStep;
  export let shareOnly = false;
  export let shareMessage = `All set! You can now share your Rec Request!`;

  let contentEl;
  let progressPercentage = 0;
  let step;

  $: if (step == STEP_NAME_DESCRIPTION) {
    progressPercentage = 33;
  } else if (step == STEP_RECOMMENDATIONS) {
    progressPercentage = 66;
  } else if (step == STEP_THANK_YOU) {
    progressPercentage = 90;
  } else if (step == STEP_SHARE) {
    progressPercentage = 100;
  }

  let close = function () {
    showModal = false;
    dispatch('close');
  };

  let open = function () {
    if (shareOnly) {
      step = STEP_SHARE;
    } else if (startStep) {
      step = startStep;
    } else if (recRequest && recRequest.id) {
      computeStep();
    } else {
      step = STEP_NAME_DESCRIPTION;
    }

    dispatch('open');
  };

  let computeStep = function () {
    if (recRequest.thank_you_message) {
      step = STEP_SHARE;
    } else if (recRequest.questions && recRequest.questions.length > 0) {
      step = STEP_THANK_YOU;
    } else {
      step = STEP_RECOMMENDATIONS;
    }
  };

  let apiRequest = async function (data, successFn) {
    let resp;

    try {
      if (recRequest && recRequest.id) {
        resp = await RecRequestAjax.update(group, recRequest, data.rec_request);
      } else {
        resp = await RecRequestAjax.create(group, data.rec_request);
      }

      recRequest = resp;
      await successFn();
      recRequestsStore.set(await RecRequestAjax.fetch(group));
    } catch (err) {
      if (err && err.full_errors && err.full_errors.length > 0) {
        Notification.send({
          text: err.full_errors[0],
        });
      }
    }
  };

  let goBack = function () {
    if (step == STEP_SHARE) {
      step = STEP_THANK_YOU;
    } else if (step == STEP_THANK_YOU) {
      step = STEP_RECOMMENDATIONS;
    } else if (step == STEP_RECOMMENDATIONS) {
      step = STEP_NAME_DESCRIPTION;
    }
  };
</script>

<style style="text/scss" lang="scss">
  .progress-bar {
    padding: 0px;
    background: white;
    height: 13px;
    width: 100%;
    border-radius: 9999px;
    overflow: hidden;
    margin-bottom: 25px;
    box-shadow: none;
    display: flex;

    .progress-indicator {
      background: #8e71ff;
      height: 100%;
      transition: 0.2s;
      margin: 0px;
      padding: 0px;
    }

    .progress-bar-remainder {
      flex: 1;
      border: 1px solid #8e71ff;
      border-top-right-radius: 6px;
      border-bottom-right-radius: 6px;
    }
  }
</style>

<div class="svelte-rec-request-modal">
  <Modal
    mobile={mobile}
    on:show={open}
    on:close={close}
    show={showModal}
    showCloseButton={false}
    fadeInDuration={200}
    style="border-radius: 16px; width: 580px;">
    <div slot="content" bind:this={contentEl}>
      {#if shareOnly == false && step != STEP_NAME_DESCRIPTION}
        <div on:click={goBack} style="position: absolute; left: 40px; top: 48px; cursor: pointer;">
          <svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.53846 14L1 7.5M1 7.5L7.53846 1M1 7.5C1 7.5 13.4038 7.5 18 7.5"
              stroke="#A893F9"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </div>
      {/if}

      <div style="padding-left: 100px; padding-right: 100px">
        {#if progressPercentage != 100}
          <div class="progress-bar">
            <div class="progress-indicator" style="width: {progressPercentage}%" />
            <div class="progress-bar-remainder" />
          </div>
        {/if}

        <!-- STEP ONE -->
        {#if step == 'name-and-description'}
          <NameAndDescription
            on:saved={() => {
              step = STEP_RECOMMENDATIONS;
            }}
            group={group}
            currentUser={currentUser}
            recRequest={recRequest}
            close={close}
            apiRequest={apiRequest} />

          <!-- STEP TWO -->
        {:else if step == STEP_RECOMMENDATIONS}
          <Recommendations
            on:saved={() => {
              step = STEP_THANK_YOU;
            }}
            group={group}
            currentUser={currentUser}
            recRequest={recRequest}
            close={close}
            apiRequest={apiRequest} />

          <!-- STEP THREE -->
        {:else if step == STEP_THANK_YOU}
          <ThankYou
            mobile={mobile}
            on:saved={() => {
              step = STEP_SHARE;
            }}
            group={group}
            currentUser={currentUser}
            recRequest={recRequest}
            close={close}
            apiRequest={apiRequest} />

          <!-- STEP FOUR -->
        {:else if step == STEP_SHARE}
          <Share
            shareMessage={shareMessage}
            showDelete={shareOnly == false}
            on:done={() => {
              close();
            }}
            group={group}
            currentUser={currentUser}
            recRequest={recRequest}
            close={close}
            apiRequest={apiRequest} />
        {/if}
      </div>
    </div>
  </Modal>
</div>
